import { ITotalsServiceSummary } from 'components/SummaryBanner/SummaryBanner.types';
import TotalsInServiceSummary from '../TotalsInServiceSummary/TotalsInServiceSummary';
import BordUploaderButton from 'components/NudosComponents/BordUploaderButton/BordUploaderButton';
import { ACCEPTED_FILE_EXTENSION } from 'components/NudosComponents/BordUploaderButton/BordUploaderButton.types';
import { CURRENCIES } from 'types/bussines';
import { useState, useCallback, ReactNode } from 'react';
import { requestOrderSummaryPDF } from 'services/orders';
import { displayErrorNotification } from 'utils/displayNudosStandardNotifications';
import './OrderSummary.scss';

interface IOrderSummaryProps {
  totals?: ITotalsServiceSummary;
  orderId?: number;
  children?: ReactNode;
}

const OrderSummary = ({
  totals = { totalUSD: 0, total: 0, currency: CURRENCIES.USD },
  orderId,
  children
}: IOrderSummaryProps) => {
  const [orderSummaryPDF, setOrderSummaryPDF] = useState('');
  const [loadingOrderSummary, setLoadingOrderSummary] = useState(false);

  const fetchOrderSummaryPDF = useCallback(async () => {
    if (!orderId) return;
    if (orderSummaryPDF) {
      window.open(orderSummaryPDF, '_blank');
      return;
    }
    setLoadingOrderSummary(true);
    try {
      const response: string = await requestOrderSummaryPDF(orderId);
      if (response) {
        window.open(response, '_blank');
        setOrderSummaryPDF(response);
      }
    } catch (error) {
      displayErrorNotification();
    } finally {
      setLoadingOrderSummary(false);
    }
  }, [orderId, orderSummaryPDF]);

  return (
    <div className="serviceSummaryBanner orderSummary">
      <TotalsInServiceSummary totals={totals} />
      <div className="orderSummaryUploaderContainer">
        <BordUploaderButton
          defaultFile={{
            documentName: 'Resumen de la orden.pdf',
            url: orderSummaryPDF || 'pending'
          }}
          loading={loadingOrderSummary}
          customClassName="orderSummaryUploader"
          customContainerClassName="orderSummaryButtonContainer"
          customFileNameClass="orderSummaryFileName"
          acceptFileExtension={[ACCEPTED_FILE_EXTENSION.PDF]}
          isFilled
          iconsCustomWidth="14px"
          handleDownloadFile={fetchOrderSummaryPDF}
          disabledBordUploaderButton={loadingOrderSummary}
        />
      </div>
      {children}
    </div>
  );
};

export default OrderSummary;
